/* eslint-disable */

// ══ شركات التوصيل التي تدعم الـ webhook (تحسب بالـ "livré") ══
// عدّل دالة check حسب الحقول الحقيقية لكل شركة عندك فـ Firestore.
export const ALGERIAN_SHIPPING_COMPANIES = [
  {
    id: "zrexpress",
    key: "zrexpress",
    nameKey: "zrexpress",
    logoUrl: "/zrexpress.png",
    check: (store) =>
      (!!store?.zrExpressApiKey_V2 && !!store?.zrExpressXTenant_V2) ||
      (!!store?.Zrexpress && !!store?.ZrexpressC),
    supportsWebhook: true,
    supportsOrderExporting: true,
  },
  {
    id: "ecotrack",
    key: "ecotrack",
    nameKey: "ecotrack",
    logoUrl: "/ecotrack.png",
    check: (store) => !!store?.Uecotrack && !!store?.Ecotrack,
    supportsWebhook: true,
    supportsOrderExporting: true,
  },
  // {
  //   id: "maystro",
  //   key: "maystro",
  //   nameKey: "maystro",
  //   logoUrl: "/maystro.svg",
  //   check: (store) => !!store?.Maystro,
  //   supportsWebhook: true,
  // },
  // {
  //   id: "yalidine",
  //   key: "yalidine",
  //   nameKey: "yalidine",
  //   logoUrl: "/yalidine.png",
  //   check: (store) =>
  //     !!store?.Yalidineid && !!store?.Yalidinetoken && !!store?.YalidineW,
  //   supportsWebhook: true,
  // },
  // {
  //   id: "nordetouest",
  //   key: "nordetouest",
  //   nameKey: "nordetouest",
  //   logoUrl: "https://app.noest-dz.com/css/customer/images/new_logo_.png",
  //   check: (store) => !!store?.Userguid && !!store?.ApitokenNord,
  //   supportsWebhook: true,
  // },
  {
    id: "maystro",
    key: "maystro",
    nameKey: "maystro",
    logoUrl: "/maystro.svg",
    check: (store) => !!store?.Maystro,
    supportsWebhook: true,
    supportsOrderExporting: true,
  },
  {
    id: "yalidine",
    key: "yalidine",
    nameKey: "yalidine",
    logoUrl: "/yalidine.png",
    check: (store) =>
      !!store?.Yalidineid && !!store?.Yalidinetoken && !!store?.YalidineW,
    supportsWebhook: true,
    supportsOrderExporting: false,
  },
  {
    id: "nordetouest",
    key: "nordetouest",
    nameKey: "nordetouest",
    logoUrl: "https://app.noest-dz.com/css/customer/images/new_logo_.png",
    check: (store) => !!store?.Userguid && !!store?.ApitokenNord,
    supportsWebhook: true,
    supportsOrderExporting: true,
  },
  {
    id: "elogistia",
    key: "elogistia",
    nameKey: "elogistia",
    logoUrl: "/elogistia-logo.png",
    check: (store) => !!store?.apielogistia,
    supportsWebhook: false,
    supportsOrderExporting: false,
  },
  {
    id: "zimou",
    key: "zimou",
    nameKey: "zimou",
    logoUrl:
      "https://media.licdn.com/dms/image/v2/D4D0BAQFZSW6TIg4J-w/company-logo_200_200/company-logo_200_200/0/1704570721462?e=2147483647&v=beta&t=uuus2Mj66LjoSgi0qr9-BckFBp6MRJPkCgZrXnbIT3Y",
    check: (store) => !!store?.zimouToken && !!store?.zimouUrl,
    supportsWebhook: false,
    supportsOrderExporting: false,
  },
  {
    id: "colivraison",
    key: "colivraison",
    nameKey: "colivraison",
    logoUrl: "https://beta.colivraison.express/images/logos/companylogo.png",
    check: (store) => !!store?.coliv_token && !!store?.coliv_pubKey,
    supportsWebhook: false,
    supportsOrderExporting: false,
  },
  {
    id: "mdm",
    key: "mdm",
    nameKey: "mdm",
    logoUrl: "/mdm.png",
    check: (store) => !!store?.mdm_apikey,
    supportsWebhook: false,
    supportsOrderExporting: false,
  },
  {
    id: "yalitec",
    key: "yalitec",
    nameKey: "yalitec",
    logoUrl: "/yalitec.png",
    check: (store) => !!store?.YalitecToken && !!store?.YalitecId,
    supportsWebhook: false,
    supportsOrderExporting: false,
  },
  {
    id: "mylerzdz",
    key: "mylerzdz",
    nameKey: "mylerzdz",
    logoUrl: "/mylerz.png",
    check: (store) =>
      !!store?.MylerzUsername ||
      !!store?.MylerzPassword ||
      !!store?.mylerzToken,
    supportsWebhook: false,
    supportsOrderExporting: false,
  },
  {
    id: "ecomDelivery",
    key: "ecomdelivery",
    nameKey: "ecomdelivery",
    logoUrl: "/ecom_delivery.png",
    check: (store) =>
      !!store?.ecomdelivery_token ||
      !!store?.ecomdelivery_key ||
      !!store?.ecomdeliveryv2_token ||
      !!store?.ecomdeliveryv2_key,
    supportsWebhook: true,
    supportsOrderExporting: true,
  },
  {
    id: "guepex",
    key: "guepex",
    nameKey: "guepex",
    logoUrl: "/guepex.png",
    check: (store) =>
      !!store?.UserguidGuepex || !!store?.Apitokenguepex || !!store?.ApitokenGW,
    supportsWebhook: true,
    supportsOrderExporting: true,
  },
  {
    id: "flashDelivery",
    key: "flashdelivery",
    nameKey: "flashdelivery",
    logoUrl: "/flash.png",
    check: (store) =>
      !!store?.flashdelivery_token || !!store?.flashdelivery_key,
    supportsWebhook: false,
    supportsOrderExporting: false,
  },
  {
    id: "osen",
    key: "osen",
    nameKey: "osen",
    logoUrl: "/osen.png",
    check: (store) => !!store?.OsenToken,
    supportsWebhook: false,
    supportsOrderExporting: false,
  },
  {
    id: "other",
    key: "other",
    nameKey: "other",
    logoUrl: "",
    check: () => true,
    supportsWebhook: false,
    supportsOrderExporting: false,
  },
];